import React, { FC } from 'react';

const Header: FC = () => {
    return (
        <div
            data-testid="universal-header"
            dangerouslySetInnerHTML={{
                __html: `<!--# block name="header_fallback" --><!--# endblock --><!--# include virtual="/__universal/header.html" stub="header_fallback" -->`
            }}
        />
    );
};

export default Header;
